import axios from "axios";
import 'react-dates/lib/css/_datepicker.css';
import React from "react";
import { render } from "react-dom";
import { BrowserRouter, Switch, withRouter } from "react-router-dom";
import { Provider } from "mobx-react";
import { AppContainer } from "react-hot-loader";
import { rehydrate, hotRehydrate } from "rfx-core";

//import { isProducao } from "./config/Constantes";
import "./config/Interceptors";
import App from "./App";
import stores from "./stores";
import Routes from './routes';
import analytics from './Analytics';

import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

import("./assets/styles/main.scss");

const store = rehydrate();

const routes = new Routes();

const Root = () => (<Switch><App /></Switch>)
const AppRoot = withRouter(analytics(Root))
const AppWithRouter = () => (<AppRoot />)

const RenderApp = Component => {
	render(
		<AppContainer>
			<BrowserRouter basename="/">
				<Provider store={hotRehydrate()} routes={routes.data} >
					<AppWithRouter />
				</Provider>
			</BrowserRouter>
		</AppContainer>,
		document.getElementById("root")
	);
};

RenderApp(App);

if (module.hot) {
	module.hot.accept('./App', () => {
		const NextApp = require('./App').default
		RenderApp(NextApp)
	})
}


export { store }


// WEBPACK FOOTER //
// ./src/index.js